import {IPhoneNumber} from '../../interfaces/phone-number/phone-number.interface';
import {IAddress} from '../../interfaces/address/address.interface';

export class HelperValidationField {

  onConfirm(value, valueToCompare, field): void {
    if (value !== valueToCompare) {
      field?.control?.setErrors({ ...field?.errors, confirm: true });
    }
  }

  onConfirmCompare(value, valueToCompare, fieldToCompare): void {
    if (value !== valueToCompare) {
      fieldToCompare?.control?.setErrors({ ...fieldToCompare?.errors, confirm: true });
    }
  }

  onValidateCP(value: IAddress, field): void {
    if (!value.cp) {
      value.cp = '';
    }
    if (value.cp && value.cp.match(/[^a-z0-9]/gi)) {
      setTimeout(() => {
        value.cp = value.cp.replace(/[^a-z0-9]/gi, '');
      }, 10);
    }
    if (value.cp && (value.cp).length < 5) {
      field?.control?.setErrors({ ...field?.errors, cpError: { message: 'Debe tener mínimo 5 caracteres' } });
    }

    if (value.cp && (value.cp).length > 6) {
      field?.control?.setErrors({ ...field?.errors, cpError: { message: 'Debe tener máximo 6 caracteres' } });
    }
    if (value.cp.length > 0) {
      value.cp += '';
    } else {
      value.cp = undefined;
    }
  }

  validCPValue(value): string {
    let message = null;
    if (value && (value).length < 5) {
      message = 'El código postal debe tener min 5 caracteres';
    }

    if (value && (value).length > 6) {
      message = 'El código postal debe tener máx 6 caracteres';
    }
    return message;
  }

  onValidatePhone(value, field): void {
    if (value) {
      let parsedValue = value.replace(/[^0-9]+/g, '');
      if (value.length > 10) {
        parsedValue = parsedValue.substring(0, 10);
      }
      if (parsedValue.length !== 10) {
        field?.control?.setErrors({ ...field?.errors, phoneError: { message: 'El teléfono debe tener 10 números' } });
      }
    }
  }

  onValidateLicense(value, field): void {
    value.item = value.item.replace(/[^0-9]+/g, '');

    if (value.item && (value.item).length < 5) {
      field?.control?.setErrors({ ...field?.errors, cpError: { message: 'Debe tener mínimo 5 caracteres' } });
    }

    if (value.item && (value.item).length > 10) {
      field?.control?.setErrors({ ...field?.errors, cpError: { message: 'Debe tener máximo 10 caracteres' } });
    }
    value += '';
  }

  onValidateYearOfCompletion(value, field): void {
    if (value && (value.toString()).length === 4) {
      const currentYear = new Date().getFullYear();
      if (value < 1950 || value > currentYear) {
        field?.control?.setErrors({ ...field?.errors, cpError: { message: 'El año esta fuera del rango' } });
      }
    }

    if (value && (value.toString()).length < 4) {
      field?.control?.setErrors({ ...field?.errors, cpError: { message: 'Debe tener mínimo 4 caracteres' } });
    }

    if (value && (value.toString()).length > 4) {
      field?.control?.setErrors({ ...field?.errors, cpError: { message: 'Debe tener máximo 4 caracteres' } });
    }
    value += '';
  }

  onValidateNumber(value: IPhoneNumber, property: string): void {
    value[property] = value[property]?.replace(/[^0-9]+/g, '');
  }

  onValidateEmail(value, field): void {
    const regex = new RegExp(/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i);
    if (!regex.test(value)) {
      field?.control?.setErrors({ ...field?.errors, invalidEmail: { message: '' } });
    }
  }

  onValidateEmailReactive(value, field): void {
    const regex = new RegExp(/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i);
    if (!regex.test(value)) {
      field?.setErrors({ ...field?.errors, invalidEmail: { message: '' } });
    }
  }

  onValidateURL(value, field): void {
    const regex = new RegExp(/^(https)?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/);
    if (!regex.test(value)) {
      field?.control?.setErrors({ ...field?.errors, invalidURL: { message: '' } });
    } else {
      field?.control?.setErrors();
    }
  }

  onCheckURL(value: { url: string }, field): void {

    const validUrl = new RegExp(/^(https)?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/);
    // const regexHttps = new RegExp(/^(https)/);
    // const regexHttp = new RegExp(/^(http)/);

    if (validUrl.test(value.url)) {
      //  si tiene https:// correcto y no hacer nada
      return;
    }
    // if (regexHttps.test(value.url)) {
    //   value.url = this.cleanUrlIncorrect(value.url);
    //   value.url = 'https://' + value.url;
    // } else if (regexHttp.test(value.url)) {
    //   // si tiene http://  cambiarlo a https://
    //   value.url = this.cleanUrlIncorrect(value.url);
    //   value.url = 'https://' + value.url;
    // } else {
    //   // si no tiene https:// pues ponerselo
    // }
    value.url = this.cleanUrlIncorrect(value.url);
    value.url = 'https://' + value.url;
    // Se puse este setTimeout porque no se estaba actualizando el error en el template
    setTimeout(() => {
      this.onValidateURL(value.url, field);
    }, 10);
  }

  cleanUrlIncorrect(value: string): string {
    value = value?.replace(/(https:\/\/)?/g, '');
    value = value?.replace(/(http:\/\/)?/g, '');
    value = value?.replace(/(https:\/)?/g, '');
    value = value?.replace(/(http:\/)?/g, '');
    value = value?.replace(/(https:)?/g, '');
    value = value?.replace(/(http:)?/g, '');
    value = value?.replace(/(https)?/g, '');
    value = value?.replace(/(http)?/g, '');
    return value;
  }

}
